var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 542.447,
    height: 387.395,
    viewBox: "0 0 542.447 387.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.ab,.aj,.b,.c,.f,.j,.p,.s,.u,.v,.y{fill:none;}.a,.b,.c,.d,.f{stroke:#c0ccd8;}.a,.ab,.aj,.c,.j,.p,.s,.u,.v,.y{stroke-miterlimit:10;}.b,.d,.f,.w{stroke-linejoin:round;}.c{stroke-width:3px;}.d,.x{fill:#fff;}.e{fill:#c0ccd8;}.f{stroke-linecap:round;}.g{fill:#d72d0c;}.h{fill:#475577;}.i{fill:#717a91;}.j{stroke:#544943;stroke-width:1.5px;}.ae,.k{opacity:0.45;}.ae,.l{fill:#8e9db2;}.m{fill:#ffcbbb;}.n,.w{fill:#e6e8ef;}.o{fill:#b9b5b2;}.p,.w{stroke:#846a6a;}.q{fill:#173789;}.r{fill:#fca32d;}.s{stroke:#ce680d;}.t{fill:#ffb548;}.u,.v{stroke:#ed841b;}.v{stroke-dasharray:3 2;}.y{stroke:#ef977f;}.z{fill:#8ebca2;}.aa{fill:#a2ccb6;}.ab{stroke:#597f6e;}.ac{fill:#dfe3e8;}.ad{fill:#e7eaf2;}.af{fill:#c6d2e0;}.ag{opacity:0.65;}.ah{opacity:0.55;fill:url(#a);}.ai{fill:#e8eaef;}.aj{stroke:#475577;stroke-width:2px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-91.985 -55.677)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 123.751,
    height: 74.75,
    rx: 3.206,
    transform: "translate(248.891 77.505)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 123.751,
    transform: "translate(248.891 91.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.978,
    cy: 1.978,
    r: 1.978,
    transform: "translate(254.906 82.374)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M267,84.352a1.978,1.978,0,1,1-1.978-1.978A1.978,1.978,0,0,1,267,84.352Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M275.138,84.352a1.978,1.978,0,1,1-1.978-1.978A1.978,1.978,0,0,1,275.138,84.352Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 39.503,
    height: 39.503,
    rx: 5.12,
    transform: "translate(178.852 120.573)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 11.314,
    cy: 11.314,
    r: 11.314,
    transform: "translate(187.29 129.01)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 15.974,
    y2: 15.974,
    transform: "translate(190.268 132.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M480.238,151.089l-8.193-8.49H345.958a10.683,10.683,0,0,1-10.683-10.683V66.36a10.683,10.683,0,0,1,10.683-10.683H472.611A10.683,10.683,0,0,1,483.294,66.36v83.495A1.777,1.777,0,0,1,480.238,151.089Z",
    transform: "translate(0.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 39.503,
    height: 39.503,
    rx: 5.12,
    transform: "translate(593.929 235.585)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M626.412,266.43a1.415,1.415,0,0,1-.473.081l-24.517.008a1.437,1.437,0,0,1-1.246-2.156l12.252-21.237a1.436,1.436,0,0,1,2.489,0l12.267,21.229a1.437,1.437,0,0,1-.772,2.076ZM602.1,264.692l23.166-.009-11.59-20.058Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M613.678,260.471h0a.868.868,0,0,1-.867-.829l-.5-8.356a1.361,1.361,0,0,1,1.359-1.423h0a1.362,1.362,0,0,1,1.361,1.422l-.49,8.357A.869.869,0,0,1,613.678,260.471Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M614.563,262.486a.884.884,0,1,1-.884-.883A.884.884,0,0,1,614.563,262.486Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M96.442,204.5a2.229,2.229,0,1,1-2.228-2.228A2.228,2.228,0,0,1,96.442,204.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M470.817,323.314a2.229,2.229,0,1,1-2.228-2.229A2.229,2.229,0,0,1,470.817,323.314Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M623.942,140.324a2.229,2.229,0,1,1-2.229-2.228A2.228,2.228,0,0,1,623.942,140.324Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M503.662,71.4a2.229,2.229,0,1,1-2.229-2.228A2.228,2.228,0,0,1,503.662,71.4Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    y2: 6.9,
    transform: "translate(619.485 213.203)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 6.901,
    transform: "translate(616.035 216.654)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    y2: 6.9,
    transform: "translate(439.101 346.141)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 6.901,
    transform: "translate(435.65 349.591)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    y2: 6.901,
    transform: "translate(293.163 58.677)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 6.9,
    transform: "translate(289.712 62.127)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    y2: 6.9,
    transform: "translate(138.696 125.375)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 6.9,
    transform: "translate(135.246 128.825)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    y2: 6.9,
    transform: "translate(127.465 284.249)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 6.9,
    transform: "translate(124.014 287.699)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    y2: 6.901,
    transform: "translate(518.615 97.746)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 6.9,
    transform: "translate(515.164 101.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M178.8,244.962h-69.05a2.185,2.185,0,0,1-2.185-2.185h0a2.184,2.184,0,0,1,2.185-2.184H178.8a2.184,2.184,0,0,1,2.185,2.184h0A2.185,2.185,0,0,1,178.8,244.962Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M585.366,189.821h-69.05a2.185,2.185,0,0,1-2.185-2.185h0a2.184,2.184,0,0,1,2.185-2.184h69.05a2.184,2.184,0,0,1,2.184,2.184h0A2.184,2.184,0,0,1,585.366,189.821Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M595.474,204.5H569.949a1.092,1.092,0,0,1-1.092-1.092h0a1.091,1.091,0,0,1,1.092-1.092h25.525a1.091,1.091,0,0,1,1.092,1.092h0A1.092,1.092,0,0,1,595.474,204.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M527.927,152.467H502.4a1.092,1.092,0,0,1-1.092-1.092h0a1.092,1.092,0,0,1,1.092-1.093h25.525a1.092,1.092,0,0,1,1.092,1.093h0A1.092,1.092,0,0,1,527.927,152.467Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M153.139,225.657H133.613a1.092,1.092,0,0,1-1.092-1.092h0a1.092,1.092,0,0,1,1.092-1.092h19.526a1.092,1.092,0,0,1,1.092,1.092h0A1.092,1.092,0,0,1,153.139,225.657Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.7,0h21.14a3.7,3.7,0,0,1,3.7,3.7v21.14a3.7,3.7,0,0,1-3.7,3.7H3.7a3.7,3.7,0,0,1-3.7-3.7V3.7A3.7,3.7,0,0,1,3.7,0Z",
    transform: "translate(572.089 129.279) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M561.862,113.806l-.5,2.451h2.727v2.177h-3.139l-.813,4.289h-2.325l.825-4.289h-3l-.8,4.289h-2.272l.782-4.289H550.83v-2.177h2.926l.5-2.451h-2.661V111.6h3.053l.813-4.3h2.314l-.813,4.3H560l.823-4.3H563.1l-.824,4.3h2.536v2.208Zm-5.814,2.451h3.025l.5-2.451h-3.024Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M21.426-3.77H7.91v-8.77H20.7v-3.633H7.91v-8.242H21.426v-3.77H3.535V0H21.426Zm9.084-7.07h6.172L42.423,0h5.059L41.154-11.523a8.087,8.087,0,0,0,5.469-8.047c0-5.254-3.652-8.613-9.336-8.613H26.134V0h4.375Zm0-13.672h6.172c3.379,0,5.449,1.895,5.449,5.039,0,3.223-1.953,5.039-5.332,5.039H30.509ZM55.628-10.84H61.8L67.542,0H72.6L66.273-11.523a8.087,8.087,0,0,0,5.469-8.047c0-5.254-3.652-8.613-9.336-8.613H51.253V0h4.375Zm0-13.672H61.8c3.379,0,5.449,1.895,5.449,5.039,0,3.223-1.953,5.039-5.332,5.039H55.628Zm32.755-4.355C80.3-28.867,75.22-23.184,75.22-14.1,75.22-5.039,80.18.684,88.384.684c8.145,0,13.145-5.742,13.145-14.785C101.528-23.164,96.489-28.867,88.384-28.867Zm0,3.867c5.332,0,8.672,4.219,8.672,10.9,0,6.621-3.32,10.918-8.672,10.918-5.43,0-8.691-4.3-8.691-10.918C79.692-20.781,83.052-25,88.384-25Zm21.838,14.16h6.172L122.135,0h5.059l-6.328-11.523a8.087,8.087,0,0,0,5.469-8.047c0-5.254-3.652-8.613-9.336-8.613H105.846V0h4.375Zm0-13.672h6.172c3.379,0,5.449,1.895,5.449,5.039,0,3.223-1.953,5.039-5.332,5.039h-6.289Z",
    transform: "translate(344.985 112.677)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-91.985 -55.677)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M317.5,326.721l-20.048-131.5h-90.3L228.8,334.563a18.889,18.889,0,0,0,19.056,16.09H399.686l1.117-12.768H330.682A13.061,13.061,0,0,1,317.5,326.721Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M232.037,326.721,212.731,200.094a5.7,5.7,0,0,0-5.748-4.868h-.177a7,7,0,0,0-6.856,7.848l20.426,131.489a18.889,18.889,0,0,0,19.056,16.09h97.792l1.117-12.768H245.22A13.061,13.061,0,0,1,232.037,326.721Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "j",
    y2: 71.776,
    transform: "translate(293.163 350.652)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M252.926,428.769h0a6.34,6.34,0,0,1,6.341-6.34h67.791a6.34,6.34,0,0,1,6.341,6.34h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M286.226,428.769h0a6.339,6.339,0,0,1,6.34-6.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M259.328,435.171a6.4,6.4,0,1,1-6.4-6.4A6.4,6.4,0,0,1,259.328,435.171Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M255.278,435.171a2.352,2.352,0,1,1-2.352-2.352A2.352,2.352,0,0,1,255.278,435.171Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M292.627,435.171a6.4,6.4,0,1,1-6.4-6.4A6.4,6.4,0,0,1,292.627,435.171Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M288.577,435.171a2.352,2.352,0,1,1-2.351-2.352A2.352,2.352,0,0,1,288.577,435.171Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M339.8,435.171a6.4,6.4,0,1,1-6.4-6.4A6.4,6.4,0,0,1,339.8,435.171Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M335.75,435.171a2.352,2.352,0,1,1-2.351-2.352A2.352,2.352,0,0,1,335.75,435.171Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M363.737,209.341l22.887-34.194,7.091,1.477c-5.418,18.251-9,25.472-9,25.472"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M390.067,182.285l3.648-5.661s6.791-1.563,9.258-2.822a10.206,10.206,0,0,0,4.8-5.378c.527-1.446.3-5.692-.32-5.76-1.46-.16-4.372,5.28-5.735,5.6s-5.785-.012-8.216.306a8,8,0,0,0-5.82,4.37l-3.741,6.786"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M378.7,185.16l4.019-5.827L393.108,184l-3.3,8.851"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M295.2,172.971s16.945-7.8,31.872,5.481,25.026,25.615,30.505,29.607l22.487-25.867,12.561,5.9c-3.312,18.734-12.607,48.611-35.353,51.686-24.61,3.328-60.7-27-60.7-27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    y1: 8.595,
    x2: 7.297,
    transform: "translate(350.275 208.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M386.227,430.759l-1.9,7.306a2.8,2.8,0,0,0,2.712,3.507h22.14a2.41,2.41,0,0,0,2.411-2.41h0a2.411,2.411,0,0,0-1.678-2.3l-15.133-6.106"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M373.466,316.619c-3.535,37.151,12.761,114.14,12.761,114.14s3.873,4.68,8.552,0c0,0,3.926-73.406,8.063-106.409"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M320.652,273.1l25.407,13.325v.259s51.854-3.48,59.7,15.032c12.278,28.986,14.368,123.27,14.368,123.27H382.172s-14.125-79.193-18.953-84.022-24.743-4.474-61.358-4.474c-41.129,0-21.052-53.029-5.739-57.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M384.8,424.989s-11.278-81.716-19.568-87.709c-10.122-7.317-57.916-2.537-57.916-2.537"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M306.647,430.759l-1.9,7.306a2.8,2.8,0,0,0,2.712,3.507H329.6a2.41,2.41,0,0,0,2.411-2.41h0a2.41,2.41,0,0,0-1.678-2.3L315.2,430.759"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M310.334,316.619c-3.535,37.151-3.687,114.14-3.687,114.14s3.873,4.68,8.553,0c0,0,13.32-73.406,17.457-106.409"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M275.834,284.77s66.651,1.074,75.37,21.269c10.722,24.835-6.951,118.95-6.951,118.95H304.078v-84.2a2.972,2.972,0,0,0-2.908-3.054c-5.564.148-17.978.148-33.741.148-41.129,0-21.052-64.01-5.739-68.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M275.834,284.77s66.651,1.074,75.37,21.269c2.906,6.731,4.415,18.19,3.639,31.846"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M309.679,424.989s.407-84.523-1.533-89.038c-2.7-6.274-11.909-3.193-33.274-3.193-41.129,0-24.374-58.883-9.061-63.433"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M250.227,295.059s21.115.512,24.315-2.687,0-17.7,0-17.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M249.71,297.893s24.106.513,27.759-2.691,0-17.728,0-17.728"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M245.639,196.79s-5.06,89.9,2.6,89.9,92.826-.259,97.819-.259-6.689-76.879-23.512-93.118c0,0-24.95-27.072-35.944-24.479S245.639,196.79,245.639,196.79Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 10.576,
    y1: 43.351,
    transform: "translate(330.077 194.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M202.556,213.07l-22.888-34.194-7.09,1.477c5.418,18.251,9,25.472,9,25.472"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M176.225,186.014l-3.647-5.661s-6.792-1.563-9.259-2.822a10.21,10.21,0,0,1-4.8-5.378c-.527-1.446-.3-5.692.32-5.76,1.46-.16,4.373,5.28,5.736,5.6s5.785-.012,8.215.306a8,8,0,0,1,5.82,4.37l3.742,6.786"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M187.6,188.889l-4.019-5.826-10.394,4.665,3.3,8.851"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M277.111,173.485s-16.747-11.91-34.043,2.717c-16.119,13.631-26.857,41.142-30.462,41.142-2.5,0-18.011-19.779-27.269-31.885l-11.013,5.887c6.94,21.193,22.072,57.242,44.714,57.242,17.765,0,54.24-41.612,54.24-41.612"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    y1: 22.51,
    x2: 26.993,
    transform: "translate(244.18 212.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M278.723,175.607l16.095,17.243,2.106-19.934"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M291.648,158.2l4.528,9.921s1.823,5.685-5.723,8.26a12.6,12.6,0,0,1-13.342-2.9l-1.194-15.569"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M276.676,167.814s5.956,7.464,13.777,8.568l-5.681,8.428c-4.6-2.593-10.23-12.654-10.23-12.654Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M295.7,166.761a20.1,20.1,0,0,1-5.248,9.621l6.471,4.891c1.487-3.66,1.316-9.359,1.316-9.359Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M298.356,142.18s4.274,16.363-2.142,20.5-17.577-2.157-18.22-4.211-3.559-19.523.627-20.833C286.061,135.306,296.172,135.2,298.356,142.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M298.218,147.489a.835.835,0,1,1-1-.622A.835.835,0,0,1,298.218,147.489Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M296.79,142.612c.282.041,1.538.171,1.272.792-.117.275-.558.268-.8.254a1.927,1.927,0,0,0-.759.033.891.891,0,0,1,.159.255c.075.185-.543.205-.612.205a3.341,3.341,0,0,0-2.111.389A2.79,2.79,0,0,1,296.79,142.612Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M287.935,149.753a.834.834,0,1,0,.787-.879A.833.833,0,0,0,287.935,149.753Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M285.462,146.449c-.6.324-1.105.763-.97,1.264.108.4.5.3.748.1a4.326,4.326,0,0,1,1.365-.73.923.923,0,0,0-.332.751,3.553,3.553,0,0,0,3.086-3.055,5.947,5.947,0,0,1-1.168.8C287.311,145.989,286.337,145.978,285.462,146.449Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M294.061,148.465s2.277,5.74,1.465,6.241-3.673.428-3.673.428"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M294.147,163.628a13.1,13.1,0,0,1-12.208-2.053"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M290.453,159.787s.578-2.531,4.742-2.531"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M301.975,133.4a3.528,3.528,0,0,0-.726-2.172,3.374,3.374,0,0,0-2.492-.787,15,15,0,0,0-8.817,2.812l2.093-1.82c.552-.481,1.788-1.239,1.193-2.135-.524-.79-2.014-.341-2.773-.35-3.579-.045-7.035,1.234-10.329,2.5a26.215,26.215,0,0,0-4.73,2.191,8.95,8.95,0,0,0-3.486,3.786,10.794,10.794,0,0,0-.734,4.481,54.943,54.943,0,0,0,.879,8.171c.468,2.953,1.177,8.775,5.144,9.128a3.257,3.257,0,0,0,2.236-.337,2.825,2.825,0,0,0,.926-2.016,10.3,10.3,0,0,0-.233-3.694c.744.4,1.446,1.076,2.28.955a.8.8,0,0,0,.654-.453,1.132,1.132,0,0,0,.025-.525c-.31-2.828-.48-5.641-.661-8.481q6.09-1.287,12.247-2.216c1.82-.275,3.747-.57,5.159-1.75C301.851,138.991,302.2,136.02,301.975,133.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M281,154.244c-.675-1.664-1.852-3.67-3.7-2.54a3.614,3.614,0,0,0-1.27,2.078c-.845,2.748,1.126,6.985,3.824,6.594,1.315-.192,2.044-1.752,2.58-3.039"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-91.985 -55.677)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M526.154,332.892a33.154,33.154,0,0,1,10.283-23.863,32.812,32.812,0,0,1,11.136-6.855c2.322-.856,13.449-1.7,13.449-1.7s-1.3,8.491-3.512,12.77c-5.167,9.977-15.386,18.364-31.356,19.643"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M558.879,358.236a27.08,27.08,0,0,1,34.526-6.34.589.589,0,0,1,.143,1.081,25.163,25.163,0,0,1-20.913,8.141,90.026,90.026,0,0,1-13.756-2.882"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M567.82,344.692c.008-7.766,2.59-14.737,7.149-19.3a21.48,21.48,0,0,1,17.991-5.859.967.967,0,0,1,.661.278,1.256,1.256,0,0,1,.214.894c-.4,9.35-5.084,17.091-12.234,20.2a70.461,70.461,0,0,1-13.781,3.788"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M579.878,330.8a65.439,65.439,0,0,1,11.1-13.462,27.687,27.687,0,0,1,5.607-4.217c6.689-3.593,14.941-2.48,22.133-.047-2.86,5.433-6.591,10.75-12.078,13.5a33.224,33.224,0,0,1-7.743,2.468c-5.262,1.171-13.668,1.057-19.014,1.754"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M576.054,317.832c-13.382-7.01-15.358-21.63-15.7-27.038-.212-3.388.009-7.156,2.832-9.6,16.582,5.837,20.815,17.062,12.864,36.633"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M518.388,315.724c1.038-7.121,2-14.771-1.242-21.2a25.477,25.477,0,0,0-4.612-6.177c-4.352-4.48-10.046-8.183-16.291-8.193a28.473,28.473,0,0,0,19.339,31.823"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M557.307,362.3a28.912,28.912,0,0,1-17.641-38.261.921.921,0,0,1,1.572-.556c11.543,6.634,19.441,25.937,16.069,38.817"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M525.94,322.968a28.285,28.285,0,0,1,13.021-33.989c2.349-1.3,4.9-2.282,6.987-3.976a65.212,65.212,0,0,1,1.419,9.51,27.87,27.87,0,0,1-.606,9.451c-2.171,7.909-9.461,13.286-16.783,16.979"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M516.27,321.768c-12.017,1.456-26.815-3.394-33.238-14.714,20.548-10.444,33.238,5.534,33.238,14.714"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M523.282,348.582c-2.7-9.229-9.787-16.8-18.33-19.565a26.239,26.239,0,0,0-25.2,5.471,1.014,1.014,0,0,0-.286,1.617c4.592,6.641,11.92,10.562,19.414,12.215s15.231,1.258,22.86.687"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M507.933,299.272c7.323,6.981,11.459,16.636,14.547,26.27,8.136,25.377,10.27,52.226,12.351,78.793"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M529.718,356.448a33.2,33.2,0,0,0-12.294-11.23,72.97,72.97,0,0,0-36.284-9.052"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M526.181,338.781c-.375-7.393-.917-14.19.324-20.737a39.924,39.924,0,0,1,7.968-18.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M498.406,310.868c7.944.644,17.864,10.9,24.876,17.244"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M552.443,379.852c4.408-29.185,26.518-54.965,54.692-63.768"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M569.057,292.418c6.591,13.294,10.705,32.186,2.563,47.052"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M578.031,370.187V381.9c0,46.455-12.231,59.669-12.231,59.669H527.926s-12.232-13.214-12.232-59.669V370.187Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-91.985 -55.677)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "j",
    y1: 153.988,
    x2: 32.116,
    transform: "translate(171.352 287.584)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "j",
    x1: 32.116,
    y1: 153.988,
    transform: "translate(203.468 287.584)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "j",
    y1: 153.988,
    x2: 32.116,
    transform: "translate(495.725 287.584)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "j",
    x1: 32.116,
    y1: 153.988,
    transform: "translate(527.841 287.584)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad",
    width: 383.624,
    height: 9.213,
    transform: "translate(172.391 278.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M537.525,260.81H401.959a3.887,3.887,0,0,1-3.827-4.567l15.577-87.613a5.814,5.814,0,0,1,5.725-4.8H555a3.886,3.886,0,0,1,3.827,4.566L543.25,256.013A5.815,5.815,0,0,1,537.525,260.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M540.675,260.81H405.109a3.886,3.886,0,0,1-3.826-4.567l15.576-87.613a5.814,5.814,0,0,1,5.725-4.8H558.15a3.886,3.886,0,0,1,3.827,4.566L546.4,256.013A5.815,5.815,0,0,1,540.675,260.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M515.733,260.81h-78.3a2.244,2.244,0,0,1-2.21-2.638l9-50.6a3.358,3.358,0,0,1,3.307-2.77h78.3a2.245,2.245,0,0,1,2.21,2.637l-9,50.6A3.358,3.358,0,0,1,515.733,260.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M517.608,260.81h-78.3a2.244,2.244,0,0,1-2.21-2.638l9-50.6a3.357,3.357,0,0,1,3.306-2.77h78.3a2.244,2.244,0,0,1,2.21,2.637l-9,50.6A3.359,3.359,0,0,1,517.608,260.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 31.777,
    height: 29.761,
    transform: "translate(468.475 231.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M498.433,231.049H468.475V239.6l8.179,33.94h31.8Zm-7.691,33.434c-3.561,0-7.326-4.153-8.409-9.276s.925-9.277,4.486-9.277,7.327,4.153,8.41,9.277S494.3,264.483,490.742,264.483Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M450.95,273.538h71.185v4.833H446.116A4.833,4.833,0,0,1,450.95,273.538Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 56.909,
    height: 4.834,
    transform: "translate(465.225 273.538)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M500.271,231.049h-31.8l10.018,42.489h31.8Zm-7.8,33.434c-3.562,0-7.327-4.153-8.41-9.276s.925-9.277,4.487-9.277,7.326,4.153,8.409,9.277S496.028,264.483,492.467,264.483Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M426.021,172.461l-1.883,10.59h1.883l1.883-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M431.471,172.461l-1.883,10.59h1.883l1.883-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M436.921,172.461l-1.883,10.59h1.883l1.883-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M442.371,172.461l-1.883,10.59h1.883l1.883-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M447.821,172.461l-1.883,10.59h1.883l1.883-10.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M497.551,172.461l-1.883,10.59h1.883l1.883-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M503.278,172.461l-1.883,10.59h1.883l1.883-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M509,172.461l-1.883,10.59H509l1.883-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M514.732,172.461l-1.883,10.59h1.883l1.883-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M520.459,172.461l-1.883,10.59h1.883l1.883-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M526.186,172.461l-1.883,10.59h1.883l1.883-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M531.913,172.461l-1.883,10.59h1.883l1.883-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M537.64,172.461l-1.883,10.59h1.883l1.883-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M543.367,172.461l-1.883,10.59h1.883l1.883-10.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M549.094,172.461l-1.883,10.59h1.883l1.883-10.59Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M280.451,254.364a2.286,2.286,0,0,0,1.244-.663c.743-1.032-.487-2.125-1.288-2.636-1.026-.655-2.44-.879-2.937-2.142-.561-1.424.41-3,1.584-3.775a15.89,15.89,0,0,1,3.258-1.4,6.312,6.312,0,0,0,3.212-2.368c.9-1.446.722-3.31.841-4.941.464-6.382,6.987-9.546,12.485-9.676,2.747-.065,6.945.919,8.772,3.055a5.44,5.44,0,0,1,1.254,2.5,4.535,4.535,0,0,1-1.222,3.845c-.941,1.08-2.239,1.708-3.269,2.679-1.066,1-.307,2.062-.55,3.258-.271,1.331-1.163,1.9-2.319,2.543-2.439,1.36-5.309,1.7-7.963,2.438a6.387,6.387,0,0,0-2.329,1.048,12.812,12.812,0,0,0-2.015,2.641,8.328,8.328,0,0,1-5,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M295.74,270.43h-5.214v-2.486h5.214a3.049,3.049,0,0,0,3.045-3.046v-4.285a3.048,3.048,0,0,0-3.045-3.045h-5.214v-2.486h5.214a5.538,5.538,0,0,1,5.531,5.531V264.9A5.537,5.537,0,0,1,295.74,270.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M0,0H21.036a0,0,0,0,1,0,0V19.29a6.124,6.124,0,0,1-6.124,6.124H6.124A6.124,6.124,0,0,1,0,19.29V0A0,0,0,0,1,0,0Z",
    transform: "translate(273.399 251.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M269.994,273.424s.2,4.947,7.893,4.947h12.059c7.689,0,7.893-4.947,7.893-4.947Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 111.28,
    height: 1.978,
    transform: "translate(327.751 276.393)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.975,
    height: 1.595,
    transform: "translate(331.556 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.975,
    height: 1.595,
    transform: "translate(343.628 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.975,
    height: 1.595,
    transform: "translate(355.699 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.975,
    height: 1.595,
    transform: "translate(367.77 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.975,
    height: 1.595,
    transform: "translate(379.841 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.975,
    height: 1.595,
    transform: "translate(391.912 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.975,
    height: 1.595,
    transform: "translate(403.984 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.975,
    height: 1.595,
    transform: "translate(416.055 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 7.975,
    height: 1.595,
    transform: "translate(428.126 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 111.28,
    height: 1.978,
    transform: "translate(329.208 276.393)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.975,
    height: 1.595,
    transform: "translate(333.013 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.975,
    height: 1.595,
    transform: "translate(345.084 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.975,
    height: 1.595,
    transform: "translate(357.155 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.975,
    height: 1.595,
    transform: "translate(369.226 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.975,
    height: 1.595,
    transform: "translate(381.297 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.975,
    height: 1.595,
    transform: "translate(393.369 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.975,
    height: 1.595,
    transform: "translate(405.44 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.975,
    height: 1.595,
    transform: "translate(417.511 274.798)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.975,
    height: 1.595,
    transform: "translate(429.582 274.798)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-91.985 -55.677)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M170.861,353.02A24.293,24.293,0,0,0,157.2,324.9c-2.107-.94-4.366-1.59-6.274-2.886a55.97,55.97,0,0,0-.511,8.243,23.974,23.974,0,0,0,1.218,8.044c2.444,6.607,9.08,10.669,15.62,13.287"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M171.549,370.737c-.226-6.355.01-16.379-1.536-21.89a34.291,34.291,0,0,0-8.159-14.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M155.316,387.507a28.478,28.478,0,0,0-11.362-19.21,28.159,28.159,0,0,0-10.235-4.627c-2.072-.477-11.644.021-11.644.021s2.03,7.094,4.385,10.5c5.489,7.937,15.11,13.969,28.856,13.318"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M146.945,363.065a53.322,53.322,0,0,0-2.5-13.514,22.229,22.229,0,0,0-2.208-5.038c-3.158-5.016-9.074-7.362-14.763-8.395-.07,4.843.485,9.934,3.146,13.915a25.788,25.788,0,0,0,4.271,4.633c3.087,2.8,8.742,5.9,12.058,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M179.25,346.338c-.891-6.117-1.716-12.687,1.067-18.208a21.877,21.877,0,0,1,3.962-5.3c3.738-3.848,8.629-7.029,13.993-7.038a24.709,24.709,0,0,1-3.217,16.76c-3.018,4.966-10.275,12.008-15.8,13.791"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M169.422,381.879A21.352,21.352,0,0,0,194.89,364a.68.68,0,0,0-.8-.939c-9.833-.05-22.042,9.34-24.671,18.814"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M149.191,359.761c8.1-4.56,13.307-13.7,13.46-23.623-5.848-.325-10.25,3.274-12.8,6.376-3.547,4.318-3.846,11.907-.663,17.247"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M155.078,375.783A17.887,17.887,0,0,1,171.6,351.23a.773.773,0,0,1,.66.218.755.755,0,0,1,.1.412c.223,4.977-1.967,9.827-5.1,13.7s-7.18,6.89-11.234,9.785"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M188.23,332.206c-6.29,6-9.842,14.29-12.495,22.565-6.988,21.8-8.822,44.86-10.609,67.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M154.824,384.353a33.727,33.727,0,0,1,1.819-13.992"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M155.78,343.037c-5.107,4.558-8.078,16.954-5.366,26.062"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M157.914,412.536c-.249-20.952-5.125-47.082-20.711-63.843"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M191.188,392.877v7.992c0,31.689-10.506,40.7-10.506,40.7H148.149s-10.506-9.014-10.506-40.7v-7.992Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x2: 510.445,
    transform: "translate(27.792 385.895)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/error_image.8c4e7fe23e3a4118a444f0fb09fa034e.svg";
export { ForwardRef as ReactComponent };